import { InfoCircleIcon } from "@datagame/ui";
import { forwardRef } from "react";

import styles from "./TooltipIcon.module.scss";

const TooltipIcon = forwardRef<HTMLSpanElement>(({ ...restProps }, forwardedRef) => {
  return (
    <span className={styles.container} {...restProps} ref={forwardedRef}>
      <InfoCircleIcon className={styles.infoIcon} />
    </span>
  );
});
TooltipIcon.displayName = "TooltipIcon";

export { TooltipIcon };
